export const PAGE_PADDING = [1, 2, 4];
export const ITEM_WIDTHS = [1, 1 / 2, 1 / 3];
export const ANALYTICS_CONTEXT = "Data Browse";
